import styled from "styled-components";
import { nativeScrollbars } from "./nativeScrollbars";
export const GlobalStyle = styled.div.withConfig({ displayName: "GlobalStyle_APC-7311-productShell", componentId: "sc-1u62su" })(({ theme, level = 1 }) => {
    const ampersands = "&".repeat(level);
    return Object.assign(Object.assign({ display: "contents" }, nativeScrollbars(theme, ampersands)), { [`${ampersands} *:focus:not(:focus-visible)`]: {
            outline: "none",
        }, [`${ampersands} :focus-visible`]: {
            outline: `1px solid ${theme.colors.apolloColorStrokeFocus}`,
            outlineOffset: "-1px",
            boxShadow: theme.colors.apolloBoxShadowFormElementFocusHighlight,
        }, [`${ampersands} :focus-visible[data-focus-border]`]: {
            border: `1px solid ${theme.colors.apolloColorStrokeFocus}`,
            boxSizing: "border-box",
            outline: "none",
        } });
});
//# sourceMappingURL=GlobalStyle.js.map